import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.42 2.75a1.75 1.75 0 0 1-2.313 1.657l.408.245 2.341 1.405 1.759-.88.894 1.79-2.25 1.125-.49.245-.471-.282L8.64 7.06l-1.92 7.69-1.94-.484 1.613-6.461.763-2.972.357-.198.485-.27a1.75 1.75 0 1 1 2.42-1.616ZM5.927 5.517l-3.475 1.93.972 1.75 1.817-1.01.686-2.67Zm2.532 6.104-.033-.048.67-2.552 1.066 1.546.055.08.039.09 1.457 3.376-1.836.792-1.418-3.284Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Walk16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var Walk16 = createIcon(IconComponent);